import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import Loader from 'src/components/Loader/Loader'
import { isEmpty } from 'src/utils/helpers'
import { hasClaimNumbers } from 'src/modules/Claims/PhoneNumbers/helper'
import intlMessages from './translations'
import intlMessagesClaims from '../translations'
import styles from './PhoneNumbers.module.less'

const NumbersGroup = props => {
  const { intl, claimNumbers, groupKey, countryIsoCode } = props

  if (
    isEmpty(claimNumbers) ||
    (!claimNumbers.hasOwnProperty(groupKey) && claimNumbers[groupKey].length > 0)
  ) {
    return ''
  }

  return claimNumbers[groupKey].map((group, key) => {
    const brokerageMessage =
      countryIsoCode && countryIsoCode.toLowerCase() === 'us'
        ? intl.formatMessage(intlMessages.claimsPhoneNumbersBrokerage)
        : intl.formatMessage(intlMessages.claimsPhoneNumbersAgency)
    return (
      <div key={'group-' + key} className={styles.group}>
        <div>
          <h4 className={styles.labelValue}>{group.company || ''}</h4>
          <div className={styles.labelType}>
            {groupKey === 'insuranceCompanies' &&
              intl.formatMessage(intlMessages.claimsPhoneNumbersInsurer)}
            {groupKey === 'brokerages' && brokerageMessage}
          </div>
        </div>

        {group.hasOwnProperty('numbers') && group.numbers.length > 0
          ? group.numbers.map((number, numberKey) => {
              const numberValue = number.hasOwnProperty('value') && number.value ? number.value : ''
              const isEmergency =
                number.hasOwnProperty('type') && number.type === 'emergency_claims'
              return (
                <div key={'phone-' + numberKey} className={styles.numberRow}>
                  <div className={styles.numberType}>
                    {isEmergency
                      ? intl.formatMessage(intlMessages.claimsPhoneNumbersEmergencyPhone)
                      : intl.formatMessage(intlMessages.claimsPhoneNumbersPhone)}
                  </div>
                  <div>
                    {/* <Icon type="phone" className={styles.numberIcon} />*/}
                    <a
                      href={'tel:' + numberValue}
                      className={'kiosk-color--primary-color ' + styles.numberLink}
                    >
                      {numberValue}
                    </a>
                  </div>
                </div>
              )
            })
          : '-'}
      </div>
    )
  })
}

class PhoneNumbers extends Component {
  componentDidMount() {
    const { history, getClaimNumbers, claimSettings } = this.props

    if (
      !(claimSettings.hasOwnProperty('showClaimNumbers') && claimSettings.showClaimNumbers === true)
    ) {
      // Use "replace" instead of "push" to allow clicking on back button to actually go back
      history.replace('/claims/form')
      return true
    }

    // Fetch "claim phones" if not received already
    if (typeof getClaimNumbers === 'function') {
      getClaimNumbers()
    }
  }

  render() {
    const { intl, labels, isGetClaimNumbersLoading, claimNumbers } = this.props

    const title =
      labels &&
      labels.features &&
      labels.features.hasOwnProperty('reportClaim') &&
      labels.features.reportClaim.label
        ? labels.features.reportClaim.label
        : intl.formatMessage(intlMessagesClaims.claimsHeader)

    return (
      <Layout>
        <Content>
          <PageTitle title={'Make a Call'} subtitle={title} showBack={true} />
          <Container fixedTop={false} className={styles.container}>
            {isGetClaimNumbersLoading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <div>
                {hasClaimNumbers(claimNumbers) ? (
                  <div className={styles.groups}>
                    <NumbersGroup groupKey={'brokerages'} {...this.props} />
                    <NumbersGroup groupKey={'insuranceCompanies'} {...this.props} />
                  </div>
                ) : (
                  <div className={styles.noRecords}>
                    {intl.formatMessage(intlMessages.claimsPhoneNumbersNoRecordsFound)}
                  </div>
                )}
              </div>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(PhoneNumbers))
